import { Routes, Route } from 'react-router-dom';
import LandingPage from './routes/index';
import TeacherPage from './routes/teacher';
import StudentPage from './routes/student';
import NotFound from './routes/NotFound';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/teacher" element={<TeacherPage />} />
      <Route path="/student" element={<StudentPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
